export { default } from './VinTag';
